/**
 * Helper para obter os labels dos ratings baseados nas configurações da empresa
 * @param {Object} company - Objeto da empresa com configurações
 * @param {number} ratingValue - Valor do rating (1-5)
 * @returns {string} Label do rating
 */
export const getRatingLabel = (company, ratingValue) => {
    const ratingLabels = company?.config?.settings?.performance?.rating_labels || {
        1: 'Não Iniciado',
        2: 'Precisa Melhorar',
        3: 'Dentro da Expectativa',
        4: 'Acima da Expectativa',
        5: 'Se Superou'
    };
    
    return ratingLabels[ratingValue] || 'Não Avaliado';
};

/**
 * Helper para obter todos os labels dos ratings
 * @param {Object} company - Objeto da empresa com configurações
 * @returns {Object} Objeto com todos os labels dos ratings
 */
export const getRatingLabels = (company) => {
    return company?.config?.settings?.performance?.rating_labels || {
        1: 'Não Iniciado',
        2: 'Precisa Melhorar',
        3: 'Dentro da Expectativa',
        4: 'Acima da Expectativa',
        5: 'Se Superou'
    };
};

const RATING_CODE_MAP = {
    IN: 1,
    BE: 2,
    DE: 3,
    AE: 4,
    SE: 5,
};

export const getRatingText = (code, company) => {
    const value = RATING_CODE_MAP[code];
    if (!value) return null;
    return getRatingLabels(company)[value];
};

export const getScoreOptions = (company) => {
    const labels = getRatingLabels(company);
    return [
        { value: 'NA', label: 'N/A' },
        { value: 'IN', label: labels[1] },
        { value: 'BE', label: labels[2] },
        { value: 'DE', label: labels[3] },
        { value: 'AE', label: labels[4] },
        { value: 'SE', label: labels[5] },
    ];
};

export const getScoreLabel = (code, company) => {
    if (code === 'NA') return 'N/A';
    return getRatingText(code, company) || code;
};


export const getHideCancelRatingBtn = (company) => {
    return company?.config?.settings?.performance?.hide_cancel_rating_btn || false;
};